module.exports = __webpack_public_path__ + "img/gb2238-80a-5-2.prt.e69ec8ab.jpg";